<template>
  <div class="tag-manage"
       id="tagManage">
    <second-menu-link-content>
      <template v-slot:header>
        <span>标签管理</span>
      </template>
      <template v-slot:content>
        <div class="btn-container">
          <el-button class="btn-blue"
                     @click="toAddTag">新建标签</el-button>
        </div>
        <div class="tags table">
          <el-table class="table-container"
                    :data="tags">
            <el-table-column label="标签名称"
                             prop="tagName"></el-table-column>
            <el-table-column label="客户数"
                             prop="customerCount"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span class="column-btn"
                      @click="updateTag(scope, scope.row)">编辑</span>
                <span class="column-btn"
                      @click="deleteTag(scope, scope.row)">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-dialog class="add-customer-tag-container"
                   :title="title"
                   :visible.sync="tagDialogVisible"
                   width="400px"
                   top="25vh">
          <!-- 黑色的线条 -->
          <div class="border"></div>
          <el-form :model="tagForm"
                   :rules="tagRules"
                   ref="tagForm"
                   label-width="100px"
                   class="address-form">
            <el-form-item label="客户标签："
                          prop="tagName">
              <el-input v-model="tagForm.tagName"
                        class="gray"
                        placeholder="请输入标签名，不超过五个汉字"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="btn-white"
                         type="primary"
                         @click="resetForm('tagForm')">取消</el-button>
              <el-button class="btn-blue"
                         @click="addOrEditTag('tagForm')">保存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import DBClient from 'models/db/client.js';
const dbClient = new DBClient();
const ADD_TAG_TITLE = '新增标签';
const EDIT_TAG_TITLE = '修改标签';
export default {
  data() {
    return {
      tagDialogVisible: false,
      title: ADD_TAG_TITLE,
      tags: [],
      currentEditedTagIndex: 0,
      currentEditedTag: null,
      tagForm: {
        tagName: ''
      },
      tagRules: {
        tagName: {
          required: true,
          message: '请输入标签名',
          trigger: 'blur'
        }
      }
    };
  },
  watch: {
    tagDialogVisible: {
      handler(newVal) {
        if (!newVal) {
          this.tagForm.tagName = '';
        }
      }
    }
  },
  methods: {
    toAddTag() {
      this._showTagDialog();
      this._showAddTagTitle();
    },
    addOrEditTag(formName) {
      // 提交新增或修改的标签
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.tagForm.tagName.length > 5) {
            this.$message({
              message: '标签长度不能超过五个汉字',
              center: true,
              type: 'error',
              duration: 1000
            });
            return false;
          }
          if (this.title === ADD_TAG_TITLE) {
            // 添加新标签
            let data = { name: this.tagForm.tagName };
            // 服务器更新
            this._addClientTag(data);
          } else if (this.title === EDIT_TAG_TITLE) {
            // 修改标签
            let data = {
              name: this.tagForm.tagName,
              id: this.currentEditedTag.id
            };
            // 服务器更新
            this._updateClientTag(data);
          }
          this.tagForm.tagName = '';
          this._hideTagDialog();
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      // 重置输入框
      this.$refs[formName].resetFields();
      this._hideTagDialog();
    },
    updateTag(scope, item) {
      this.currentEditedTagIndex = scope.$index;
      this.currentEditedTag = item;
      this.tagForm.tagName = item.tagName;
      this._showTagDialog();
      this._showEditTagTitle();
    },
    deleteTag(scope, item) {
      this.$confirm('即将删除此标签，是否继续', '操作提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          this.currentEditedTagIndex = scope.$index;
          let data = {
            id: item.id
          };
          // 服务器更新
          this._deleteClientTag(data);
        })
        .catch(action => {
          if (action === 'cancel') {
            // 取消删除，什么也不做
          }
        });
    },
    _showTagDialog() {
      this.tagDialogVisible = true;
    },
    _hideTagDialog() {
      this.tagDialogVisible = false;
    },
    _showEditTagTitle() {
      this.title = EDIT_TAG_TITLE;
    },
    _showAddTagTitle() {
      this.title = ADD_TAG_TITLE;
    },
    // 计算字符长度
    _getChartLength(str) {
      let strLength = 0; // 记录字符的字节数
      for (let i = 0; i < str.length; i++) {
        // 遍历字符串中的每个字符
        if (str.charCodeAt(i) > 255) {
          // 如果当前字符的编码大于255
          strLength += 2; // 所占字节数加2
        } else {
          strLength += 1; // 否则所占字节数加1
        }
      }
      return strLength; // 返回字符所占字节数
    },
    _getClientTagList() {
      dbClient.getClientTagList().then(res => {
        // 先重置为空
        this.tags = [];
        res.result.map(item => {
          this.tags.push({
            id: item.id,
            tagName: item.value,
            customerCount: item.count
          });
        });
      });
    },
    _addClientTag(data) {
      console.log('添加的data--', data);
      dbClient
        .addClientTag(data)
        .then(res => {
          if (res.success) {
            this._successAddTagTip();
            // 重新加载标签数据
            this._getClientTagList();
          } else {
            this._failAddTagTip(res.message);
          }
        })
        .catch(e => {
          this._failAddTagTip();
        });
    },
    _updateClientTag(data) {
      dbClient
        .updateClientTag(data)
        .then(res => {
          if (res.success) {
            this._successUpdateTagTip();
            // 重新加载数据
            this._getClientTagList();
          } else {
            this._failUpdateTagTip(res.message);
          }
        })
        .catch(e => {
          this._failUpdateTagTip();
        });
    },
    _deleteClientTag(data) {
      dbClient
        .deleteClientTag(data)
        .then(res => {
          if (res.success) {
            this._successDeleteTagTip();
            // 重新加载数据
            this._getClientTagList();
          } else {
            this._failDeleteTagTip(res.message);
          }
        })
        .catch(e => {
          this._failDeleteTagTip();
        });
    },
    _successAddTagTip() {
      this.$message({
        message: '添加成功',
        center: true,
        type: 'success',
        duration: 1000
      });
    },
    _failAddTagTip(message = '添加失败，请重试') {
      this.$message({
        message: message,
        center: true,
        type: 'success',
        duration: 1000
      });
    },
    _successUpdateTagTip() {
      this.$message({
        message: '修改标签成功',
        center: true,
        type: 'success',
        duration: 1000
      });
    },
    _failUpdateTagTip(message = '更新失败，请重试') {
      this.$message({
        message: message,
        center: true,
        type: 'success',
        duration: 1000
      });
    },
    _successDeleteTagTip() {
      this.$message({
        message: '删除标签成功',
        center: true,
        type: 'success',
        duration: 1000
      });
    },
    _failDeleteTagTip(message = '删除失败，请重试') {
      this.$message({
        message: message,
        center: true,
        type: 'success',
        duration: 1000
      });
    }
  },
  created() {
    this._getClientTagList();
  },
  components: {
    SecondMenuLinkContent
  }
};
</script>

<style lang="scss" scoped>
.tag-manage {
  width: 100%;
  height: 100%;
  font-size: 14px;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  color: rgba(96, 98, 102, 1);
  .tags {
    margin-top: 16px;
    .column-btn {
      font-size: 12px;
      font-family: "PingFangSC-Regular";
      font-weight: 400;
      color: rgba(61, 116, 242, 1);
      cursor: pointer;
      margin-right: 16px;
    }
  }
  .pagination-tpl-container {
    padding: 10px 24px 0px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>

<style lang="scss">
#tagManage {
  .el-dialog {
    .el-dialog__header {
      .el-dialog__title {
        font-size: 16px;
        font-weight: 550;
        color: rgba(96, 98, 102, 1);
      }
    }
    .el-dialog__body {
      .el-form {
        .el-form-item {
          &:last-child {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
          }
          .el-form-item__content {
            .el-select {
              width: 400px;
            }
          }
        }
      }
    }
  }
}
</style>
